/**
 * @flow
 * Created by neo on 01.06.17.
 */

import {observable, computed} from 'mobx';
import Address from '../Address';

export default class ContactInfo {
  @observable address: Address = new Address();
  @observable phoneNumber: string;
  @observable mobileNumber: string;
  @observable faxNumber: string;
  @observable email: string;

  constructor(json?: any) {
    if(json) {
      this.address = new Address(json.address);
      this.phoneNumber = json.phoneNumber;
      this.mobileNumber = json.mobileNumber;
      this.faxNumber = json.faxNumber;
      this.email = json.email;
    }
  }
  
  isValid(field: string): boolean {
    console.log(`ContactInfo::isValid ${field}`);
    return field && field.trim().length > 0;
  }
  
  @computed get valid(): boolean {
    return this.address.valid
      && (this.isValid(this.phoneNumber) || this.isValid(this.mobileNumber))
      && this.isValid(this.email);
  }
  
  @computed get invalid(): boolean {
    return !this.valid;
  }
}



// WEBPACK FOOTER //
// ./src/App/Store/Person/ContactInfo.js